import React from "react";
import { Edit, Plus } from "lucide-react";
import { ModalMode } from "./AddResourceModal";

interface ModeSelectionStepProps {
  connectedCount: number;
  onSelectMode: (mode: ModalMode) => void;
}

export const ModeSelectionStep: React.FC<ModeSelectionStepProps> = ({
  connectedCount,
  onSelectMode,
}) => {
  return (
    <div className="py-2 space-y-4">
      <p className="text-sm text-gray-600 font-medium">
        What would you like to do?
      </p>

      <div className="space-y-3">
        {/* Card 1: Update Existing Resource */}
        <div
          onClick={() => onSelectMode("update_existing")}
          className="group flex items-start gap-4 p-4 rounded-xl border border-gray-200 hover:border-amber-400 hover:bg-amber-50/40 cursor-pointer transition-all duration-150 shadow-2xs"
        >
          <div className="p-3 rounded-lg bg-amber-50 border border-amber-100 text-amber-600 group-hover:scale-105 transition-transform shrink-0">
            <Edit className="w-5 h-5" />
          </div>
          <div className="space-y-1 pt-0.5">
            <h4 className="text-sm font-semibold text-gray-900 group-hover:text-amber-800 transition-colors">
              Update Existing Resource
            </h4>
            <p className="text-xs text-gray-500 leading-relaxed">
              Replace or modify one of the {connectedCount} currently connected resources.
            </p>
          </div>
        </div>

        {/* Card 2: Add New Resource */}
        <div
          onClick={() => onSelectMode("add_new")}
          className="group flex items-start gap-4 p-4 rounded-xl border border-gray-200 hover:border-blue-400 hover:bg-blue-50/40 cursor-pointer transition-all duration-150 shadow-2xs"
        >
          <div className="p-3 rounded-lg bg-blue-50 border border-blue-100 text-blue-600 group-hover:scale-105 transition-transform shrink-0">
            <Plus className="w-5 h-5" />
          </div>
          <div className="space-y-1 pt-0.5">
            <h4 className="text-sm font-semibold text-gray-900 group-hover:text-blue-800 transition-colors">
              Add New Resource
            </h4>
            <p className="text-xs text-gray-500 leading-relaxed">
              Select a utility service, resource type and sub-type, then pick from the available inventory.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
